import type React from "react"
import { useTranslation } from "react-i18next"

import { selectableLanguageCodes } from "@/models/i18n"
import { TextField } from "@/nzds/inputs/text-field"
import type { FormFieldVariant } from "@/styles/form-field-variant"
import { getSelectableLanguageCode } from "@/utils/i18n"

import { MenuItem } from "@mui/material"

interface LanguageSwitcherProps {
  compact?: boolean
  id?: string
  variant?: FormFieldVariant
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  compact = false,
  id,
  variant,
}) => {
  const { i18n, t } = useTranslation(["common", "user-settings"])
  const selectedLanguageCode = getSelectableLanguageCode(i18n.resolvedLanguage)
  const languageLabel = t("languageLabel", { ns: "user-settings" })

  return (
    <TextField
      id={id}
      label={languageLabel}
      margin={compact ? "none" : "dense"}
      onChange={(event) => {
        void i18n.changeLanguage(event.target.value)
      }}
      select
      slotProps={{
        select: {
          inputProps: compact
            ? undefined
            : { "data-testid": "language-select" },
        },
      }}
      value={selectedLanguageCode}
      variant={variant}
    >
      {selectableLanguageCodes.map((selectableLanguageCode) => (
        <MenuItem
          key={selectableLanguageCode}
          data-testid={`language-select-option-${selectableLanguageCode}`}
          value={selectableLanguageCode}
        >
          {t(`language.${selectableLanguageCode}`, { ns: "common" })}
        </MenuItem>
      ))}
    </TextField>
  )
}
